import { ChildTransactionPayment } from 'types';
import { jsonObjectsTexts } from 'consts/text';
import { parseStringIntoFormattedStringDate } from 'utils/parsers/dateTime/parseStringIntoFormattedStringDate';
import { getFormattedPrice } from 'utils/getFormattedPrice';
import { getChildPaymentTransactionTypeText } from 'utils/getChildPaymentTransactionTypeText';
import { childPaymentFormTypeLabels } from 'consts/settlementChildren/childPaymentFormTypeLabels';

export const parseChildPaymentIntoJsonObject: (childPayment: ChildTransactionPayment) => object = (
    childPayment,
) => {
    const { dateTime, amount, paymentMethod, type } = childPayment;

    const formattedDate = parseStringIntoFormattedStringDate(dateTime);
    const paymentFormTypeLabel = childPaymentFormTypeLabels[paymentMethod];
    const transactionTypeLabel = getChildPaymentTransactionTypeText(type);
    const formattedAmount = getFormattedPrice(amount);

    return {
        [jsonObjectsTexts.childPayment.fields.date]: formattedDate,
        [jsonObjectsTexts.childPayment.fields.amount]: formattedAmount,
        [jsonObjectsTexts.childPayment.fields.paymentFormType]: paymentFormTypeLabel,
        [jsonObjectsTexts.childPayment.fields.transactionType]: transactionTypeLabel,
    };
};
